import type { AuditEntryDto, CreateInternalNoteInput, InternalNoteDto } from "@tc/shared";
import { ApiError } from "@/features/trips/api";

const API_URL = import.meta.env.VITE_API_URL ?? "/api";

async function req<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${API_URL}${path}`, {
    headers: { accept: "application/json", "content-type": "application/json" },
    ...init,
  });
  if (!res.ok) {
    let message = `Request failed (${res.status})`;
    try {
      const body = (await res.json()) as { message?: string | string[] };
      if (body?.message)
        message = Array.isArray(body.message) ? body.message.join(", ") : body.message;
    } catch {
      /* non-JSON error body — keep the status message */
    }
    throw new ApiError(message, res.status);
  }
  return (res.status === 204 ? undefined : await res.json()) as T;
}

/**
 * Internal-notes + per-trip audit calls (TW-3457) — a back-office-only surface (the server gates
 * both on `@UserType("BACK_OFFICE")`, with RLS as the backstop, so a club user never reaches it).
 */
export const notesApi = {
  listNotes: (tripId: string) => req<InternalNoteDto[]>(`/trips/${tripId}/notes`),
  createNote: (tripId: string, body: CreateInternalNoteInput) =>
    req<InternalNoteDto>(`/trips/${tripId}/notes`, { method: "POST", body: JSON.stringify(body) }),
  listAudit: (tripId: string) => req<AuditEntryDto[]>(`/trips/${tripId}/audit`),
};
